import { COUNTRY_CODE} from './const'

export const getPhonePrefixForCountryCode = (countryCode) => {
    switch (countryCode) {
    case COUNTRY_CODE.AT:
        return '43'
    case COUNTRY_CODE.CH:
        return '41'
    case COUNTRY_CODE.DE:
        return '49'
    case COUNTRY_CODE.ES:
        return '34'
    case COUNTRY_CODE.GB:
        return '44'
    default:
        return '49'
    }
}

export const transformPhoneNumber = (phone, countryCode) => {
    if (!phone) {
        return null
    }
    const startsWithPlus = phone.startsWith('+')
    const startsWithDoubleZero = phone.startsWith('00')

    let transformedNumber = phone.replace(/[^0-9]/g, '')
    transformedNumber = transformedNumber.replace(/\s/g, '')


    if (startsWithPlus) {
        return transformedNumber
    }

    if (startsWithDoubleZero) {
        return transformedNumber.substring(2)
    }

    return getPhonePrefixForCountryCode(countryCode) + transformedNumber.substring(1)
}





// WEBPACK FOOTER //
// ./src/modules/internationalization/phone-util.js